import type { CSSProperties, ImgHTMLAttributes } from 'react'

export type NextImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, 'width' | 'height'> & {
  src: string
  alt: string
  width?: number | string
  height?: number | string
  priority?: boolean
  /** Next.js-style layout fill — maps to a positioned <img> */
  fill?: boolean
  /** Passed through for responsive hints (native <img> ignores); kept for compatibility */
  sizes?: string
  unoptimized?: boolean
}

export default function Image({
  src,
  alt,
  width,
  height,
  className,
  style,
  priority: _priority,
  fill,
  sizes: _sizes,
  unoptimized: _unoptimized,
  ...rest
}: NextImageProps) {
  if (fill) {
    return (
      <img
        src={src}
        alt={alt}
        className={className ?? 'absolute inset-0 h-full w-full'}
        style={style as CSSProperties}
        {...rest}
      />
    )
  }

  const w = typeof width === 'string' ? width : width
  const h = typeof height === 'string' ? height : height

  return (
    <img
      src={src}
      alt={alt}
      width={w as number | undefined}
      height={h as number | undefined}
      className={className}
      style={style}
      {...rest}
    />
  )
}
